export default "__VITE_ASSET__Fh7TPlBb__"